import UserProfile from '../../shared/models/userProfile';

export interface UserProfileState {
    profile: UserProfile;
}

export const userProfileInitialState: { profile: UserProfile, version: number } = {
  profile: {
    userId: '',
    cultureCode: '',
    language: '',
    isAuthenticated: false,
    generalInformation: null,
    medicalBackground: null,
    healthcareProvider: null,
  },
  version: 1
};
